import classnames from 'classnames/bind'
import { ButtonDrawer } from '~/components'
import * as styles from './index.module.css'
import { useTranslation } from 'react-i18next'

const cx = classnames.bind(styles)

export default function OptionsPanel({ title, isOpen, onClose, children, noPadding, fullscreen, alternateBackground }) {
  const { t } = useTranslation()

  const buttons = [
    { func: onClose, title: t('button-done'), tabIndex: isOpen ? 0 : -1 },
  ]

  return (
    <div className={cx(styles.wrapper, { isOpen, fullscreen })}>
      <div className={cx(styles.overlay, { fullscreen })} onClick={onClose}></div>
      <div className={cx(styles.panel, { fullscreen })}>
        <div className={cx(styles.panelContent, { fullscreen, noPadding })}>
          {title && <div className={styles.title}>{title}</div>}
          {children}
        </div>
        {!fullscreen && (
          <>
            <ButtonDrawer buttons={buttons} className={alternateBackground ? styles.alternateBackground : null} />
          </>
        )}
      </div>
    </div>
  )
}
